import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import Blog from '../components/Blog';
import Hero from '../components/Hero';
// import Author from '../components/Footer/Author';
// require('prismjs/themes/prism-okaidia.css');
// require('prismjs/themes/prism-twilight.css');
import Seo from '../components/Seo';
import Article from '../components/Article';
import Post from '../components/Post';
import { ThemeContext } from '../layouts/Layout';
import { insertScript, removeScript } from '../utils/helpers';
import config from '../../content/meta/meta-config';
import GoogleAd from '../components/Ad';
import { css } from '@linaria/core';
const PostTemplate = (props) => {
  const {
    data: {
      post,
      post: {
        frontmatter: {
          author,
          title,
          category,
          showHero,
          showHeroTitle,
          heroTitle,
          heroSubTitle,
          heroCaption,
          heroCaptionEx,
          coverHero,
          cover,
        },
      },
      authorInfo: { nodes: authorInfos = [] },
      relevantPosts: { edges: relevantPosts = [] },
      site: {
        siteMetadata: { facebook, disqus },
      },
    },
    pageContext: { next, prev },
  } = props;

  const authorCurrent = authorInfos.filter((item) => item.frontmatter.author === author);
  const authorNote = authorCurrent && authorCurrent.length === 1 ? authorCurrent[0].html : null;

  // TODO: need to re-enable 2024 Feb
  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     load3rdPartyScript();
  //     // console.log('useEffect post template mount:', props);
  //   }
  //   return () => {
  //     if (typeof window !== 'undefined') {
  //       // console.log('useEffect post template unmount:', props);
  //       remove3rdPartyScript();
  //     }
  //   };
  // }, []);

  const decodeURI = (uri) => {
    return decodeURIComponent(uri).slice(1); // take the ID after hash '#'
  };

  useEffect(() => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    // console.debug('anchorLinks:', anchorLinks);
    const processClickEvent = (e) => {
      const target = document.getElementById(decodeURI(e.currentTarget.hashID));
      // console.debug('scroll to ID:', decodeURI(hashID));
      // console.debug('scroll to target:', target);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        history.pushState(null, null, e.currentTarget.hashID);
        e.preventDefault();
      }
    };

    for (const item of anchorLinks) {
      item.hashID = item.getAttribute('href');
      item.addEventListener('click', processClickEvent);
    }
    return () => {
      for (const item of anchorLinks) {
        item.removeEventListener('click', processClickEvent);
      }
    };
  }, []);

  const load3rdPartyScript = () => {
    const doc = window.document;
    // google adsense
    insertScript(
      '(adsbygoogle = window.adsbygoogle || []).push({});',
      'google-adsense-scr-txt',
      doc.body,
      'text/javascript'
    );
    // Remove all agoda/klook ad search bar
    // if (category === '旅行日誌') {
    //   // klook script
    //   insertScript(
    //     'https://cdn.klook.com/s/dist_web/klook-affiliate-front/static/widget/iframe/iframe-init-v1.0.10.js',
    //     'klook-search-scr',
    //     doc.body
    //   );
    //   // airbnb script
    //   // insertScript('https://www.airbnb.com.tw/embeddable/airbnb_jssdk', 'airbnb-scr', doc.body);

    //   // agoda scripts
    //   // insertScript(
    //   //   `var stg = new Object(); stg.crt="8558746297649";stg.version="1.05";stg.id=stg.name="adgshp-1908094631"; stg.Width="300px";stg.Height="300px";stg.RefKey="NYp6dAn8Gc/VWtyPfcq6eg==";stg.AutoScrollSpeed=3000;stg.AutoScrollToggle=true;stg.SearchboxShow=false;stg.DiscountedOnly=false;stg.Layout="squaredynamic"; stg.Language="en-us";stg.ApiKey="0efe9b9e-ccc1-4387-b1aa-3d701c43a2e0";stg.Cid="1881633"; stg.City="5085";stg.Currency="USD";stg.OverideConf=false; new AgdDynamic('adgshp-1908094631').initialize(stg);`,
    //   //   'agoda-ad-scr-txt',
    //   //   doc.body,
    //   //   'text/javascript'
    //   // );

    //   // insertScript('//cdn0.agoda.net/images/sherpa/js/sherpa_init1_08.min.js', 'agoda-search-scr', doc.body);
    //   // TODO: change stg.crt & stg.City & stg.DestinationName base on destination
    //   //   insertScript(
    //   //     `var stg = new Object(); stg.crt="8646198792211";stg.version="1.04";
    //   //        stg.id=stg.name="adgshp1683589233"; stg.width="1198px";
    //   //        stg.height="340px";stg.ReferenceKey="L9z1WIRATJRhWVMZ5bpzdQ=="; stg.Layout="SquareCalendar";
    //   //        stg.Language="zh-tw";stg.Cid="1881633"; stg.City="102632"; stg.DestinationName="大溪地, 法屬玻里尼西亞";
    //   //        stg.OverideConf=false; new AgdSherpa(stg).initialize();
    //   // `,
    //   //     'agoda-search-scr-txt',
    //   //     doc.body,
    //   //     'text/javascript'
    //   //   );
    //   //   insertScript(
    //   //     `var settings = new Object(); settings.refKey='DotYgCo8oAKrAo8Sx/Mhjw==';
    //   //   settings.checkIn='2020-06-29'; settings.checkOut='2020-07-05'; settings.language='zh-tw';
    //   //   settings.currency='TWD'; settings.searchRadius=5; settings.cid=1881633; settings.latitude=23.155454;
    //   //   settings.longitude=120.105589; settings.destination='台南市; 台灣'; settings.isOverideConf=false;
    //   //   settings.city=18347; settings.numberOfChildren=0; settings.numberOfAdult=2; settings.numberOfRoom=1;
    //   //   settings.crt='8550743519647'; settings.ver=1;new AgdMaps('adgshp-2068951212', settings).render();
    //   // `,
    //   //     'agoda-map-scr-txt',
    //   //     doc.body,
    //   //     'text/javascript'
    //   //   );
    // }
  };
  const remove3rdPartyScript = () => {
    const doc = window.document;
    removeScript('google-adsense-scr-txt', doc.body);
    // if (category === '旅行日誌') {
    //   removeScript('klook-search-scr', doc.body);
    // removeScript('airbnb-scr', doc.body);
    // removeScript('agoda-ad-scr-txt', doc.body);
    // removeScript('agoda-search-scr-txt', doc.body);
    // removeScript('agoda-map-scr-txt', doc.body);
    // }
  };

  let heroBackgrounds;
  // console.log('🚀 ~ file: PostTemplate.js ~ line 150 ~ PostTemplate ~ coverHero', coverHero);
  // console.log('🚀 ~ file: PostTemplate.js ~ line 150 ~ PostTemplate ~ cover', cover);
  if (coverHero) {
    heroBackgrounds = {
      heroBgMobile: coverHero?.childImageSharp?.heroImageBgMobile?.src ?? '',
      heroBgDesktop: coverHero?.childImageSharp?.heroImageBgDesktop?.src ?? '',
      heroBgTablet: coverHero?.childImageSharp?.heroImageBgTablet?.src ?? '',
    };
  } else {
    heroBackgrounds = {
      heroBgMobile: cover?.childImageSharp?.heroImageBgMobile?.src ?? '',
      heroBgDesktop: cover?.childImageSharp?.heroImageBgDesktop?.src ?? '',
      heroBgTablet: cover?.childImageSharp?.heroImageBgTablet?.src ?? '',
    };
  }

  const seoItemList = relevantPosts.map((relevantPost) => config.siteUrl + relevantPost.node.fields.slug);
  // console.debug('post seoItemList', seoItemList);
  post.seoItemList = seoItemList;

  return (
    <React.Fragment>
      <Seo data={post} facebook={facebook} />
      <ThemeContext.Consumer>
        {(theme) => (
          <>
            {showHero === null || showHero !== false ? (
              (showHeroTitle === null || showHeroTitle !== false) && heroTitle && heroSubTitle ? (
                <Hero
                  backgrounds={heroBackgrounds}
                  theme={theme}
                  isParallaxImageScrollDirectionDown={false}
                  headerTitle={heroTitle}
                  headerSubTitle={heroSubTitle}
                  isPost={true}
                  heroCaption={heroCaption}
                  heroCaptionEx={heroCaptionEx}
                />
              ) : (showHeroTitle === null || showHeroTitle !== false) && heroTitle ? (
                <Hero
                  backgrounds={heroBackgrounds}
                  theme={theme}
                  isParallaxImageScrollDirectionDown={false}
                  headerTitle={heroTitle}
                  isPost={true}
                  heroCaption={heroCaption}
                  heroCaptionEx={heroCaptionEx}
                />
              ) : showHeroTitle === null || showHeroTitle !== false ? (
                <Hero
                  backgrounds={heroBackgrounds}
                  theme={theme}
                  isParallaxImageScrollDirectionDown={false}
                  headerTitle={title}
                  isPost={true}
                  heroCaption={heroCaption}
                  heroCaptionEx={heroCaptionEx}
                />
              ) : (
                <Hero
                  backgrounds={heroBackgrounds}
                  theme={theme}
                  isParallaxImageScrollDirectionDown={false}
                  isPost={true}
                  heroCaption={heroCaption}
                  heroCaptionEx={heroCaptionEx}
                />
              )
            ) : null}
            <Article theme={theme} isPost={true} showHero={showHero}>
              <Post
                post={post}
                next={next}
                prev={prev}
                disqus={disqus}
                theme={theme}
                authorNote={authorNote}
              />
            </Article>
            <section className={adSection}>
              {/* {category === '旅行日誌' ? (
                <ins
                  className="klk-aff-widget"
                  data-height="340px"
                  data-wid="15201"
                  data-adid="576428"
                  data-lang="zh-TW"
                  data-prod="search_vertical"
                  data-currency="TWD"
                  style={{ height: '340px' }}
                >
                  <a href="//www.klook.com/?aid=">Klook.com</a>
                </ins>
              ) : null} */}
              {/* <div id="adgshp-2068951212" style={{ width: '100%', height: '500px' }} /> */}
              {/* <div id="adgshp-1908094631" /> */}
              {/* <div className="airbnb-embed-frame" data-view="a4p_search_embeddable" data-id="25845" /> */}
              {/* <div
              className="airbnb-embed-frame"
              data-view="a4p_event_embeddable"
              data-id="23845"
              data-height="620"
              style={{ height: '620px' }}
            /> */}
              <GoogleAd
                id="postAd1"
                slot="9433178566"
                customStyle={{ display: 'block', textAlign: 'center', margin: '2em 0px' }}
              />
            </section>

            {relevantPosts.length > 0 ? (
              <Blog posts={relevantPosts} category={category} theme={theme} isRelevantPosts={true} />
            ) : null}
            {/* <Author note={authorNote} theme={theme} /> */}
            <section className={adSection}>
              <GoogleAd id="postAd2" slot="2200633996" format="fluid" />
            </section>
          </>
        )}
      </ThemeContext.Consumer>
    </React.Fragment>
  );
};

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
};

export default PostTemplate;

const adSection = css`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
`;

//eslint-disable-next-line no-undef
export const postQuery = graphql`query PostBySlug($slug: String!, $postTag: String!) {
  post: markdownRemark(fields: {slug: {eq: $slug}}) {
    id
    html
    excerpt
    fields {
      slug
      prefix
    }
    frontmatter {
      title
      datePublished
      dateModified
      showHero
      showHeroTitle
      heroTitle
      heroSubTitle
      heroCaption
      heroCaptionEx
      showPostTitle
      author
      category
      tags
      coverHero {
        childImageSharp {
          heroImageBgMobile: resize(
            width: 450
            height: 850
            quality: 70
            cropFocus: CENTER
          ) {
            src
          }
          heroImageBgDesktop: resize(width: 1440, quality: 70, cropFocus: CENTER) {
            src
          }
          heroImageBgTablet: resize(width: 1440, quality: 70, cropFocus: CENTER) {
            src
          }
        }
      }
      cover {
        publicURL
        childImageSharp {
          seoImage: resize(width: 1200) {
            src
          }
          seoImage16x9: resize(width: 1600, height: 900, quality: 70, cropFocus: CENTER) {
            src
          }
          seoImage4x3: resize(width: 1024, height: 768, quality: 70, cropFocus: CENTER) {
            src
          }
          seoImage1x1: resize(width: 900, height: 900, quality: 70, cropFocus: CENTER) {
            src
          }
          heroImageBgMobile: resize(
            width: 450
            height: 850
            quality: 70
            cropFocus: CENTER
          ) {
            src
          }
          heroImageBgDesktop: resize(width: 1440, quality: 70, cropFocus: CENTER) {
            src
          }
          heroImageBgTablet: resize(width: 1440, quality: 70, cropFocus: CENTER) {
            src
          }
        }
      }
      seoKeywords
    }
  }
  authorInfo: allMarkdownRemark(
    filter: {fileAbsolutePath: {regex: "//parts/author/"}}
  ) {
    nodes {
      frontmatter {
        author
      }
      html
    }
  }
  relevantPosts: allMarkdownRemark(
    filter: {fileAbsolutePath: {regex: "//posts/[0-9]+.*--/"}, fields: {slug: {ne: $slug}}, frontmatter: {tags: {in: [$postTag]}}}
    sort: {frontmatter: {datePublished: DESC}}
    limit: 9
  ) {
    edges {
      node {
        excerpt
        fields {
          slug
          prefix
        }
        frontmatter {
          title
          datePublished
          dateModified
          category
          tags
          author
          cover {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, transformOptions: {cropFocus: CENTER})
            }
          }
        }
      }
    }
  }
  site {
    siteMetadata {
      facebook {
        appId
      }
      disqus {
        shortname
      }
    }
  }
}`;
